export default __webpack_public_path__ + "static/media/jobFairEng.bacbedac.png";